import AbstractDeviceSetup from "../all/AbstractDeviceSetup";

class KepplerDeviceSetup extends AbstractDeviceSetup {
  constructor() {
    super();
  }
}

export default KepplerDeviceSetup;



// WEBPACK FOOTER //
// ./src/devices/kepler/DeviceSetup.js